<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->
<template>
    <!-- Contact Modal - Teleported to body to escape parent modal stacking context -->
    <Teleport to="body">
        <div v-if="modelValue" id="contactModal" class="fixed inset-0 flex items-center justify-center p-4"
            style="z-index: 999999;">
            <div class="fixed inset-0 bg-black bg-opacity-50" @click="closeModal"></div>
            <div class="relative bg-white rounded-lg pt-4 pb-6 px-6 max-h-[90vh] overflow-y-auto w-full max-w-xl"
                style="z-index: 1000000;">
            <div>
                <!-- Modal Content Form Contact -->
                <div class="modal-content-form">
                    <div class="flex justify-between items-center border-b border-gray-100 pb-3 mb-4">
                        <span class="text-lg font-semibold text-gray-800">Select or Add Contact</span>
                        <a href="#" class="text-2xl text-gray-400 hover:text-gray-600 transition-colors" @click.prevent="closeModal">&times;</a>
                    </div>

                    <form class="mb-6" @submit.prevent="handleSubmitNewContact">
                        <div class="mb-4">
                            <label class="label py-1">
                                <span class="label-text text-xs text-gray-500">Name</span>
                            </label>
                            <input v-model="newContact.name" type="text"
                                class="input input-sm input-bordered w-full text-sm bg-white border-gray-200 focus:border-cs-main-500" required>
                            <div v-if="inputContactErrors.name" class="text-red-500 text-xs mt-1">
                                {{ inputContactErrors.name }}
                            </div>
                        </div>

                        <div class="mb-4">
                            <label class="label py-1">
                                <span class="label-text text-xs text-gray-500">Email</span>
                            </label>
                            <input v-model="newContact.email" type="email"
                                class="input input-sm input-bordered w-full text-sm bg-white border-gray-200 focus:border-cs-main-500" required>
                            <div v-if="inputContactErrors.email" class="text-red-500 text-xs mt-1">
                                {{ inputContactErrors.email }}
                            </div>
                        </div>

                        <div class="flex justify-end gap-3 mt-4 pt-4 border-t border-gray-100">
                            <button type="button" class="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 transition-colors" @click="closeModal">
                                Cancel
                            </button>
                            <button type="submit" class="px-4 py-2 text-sm font-medium text-white bg-cs-main-500 hover:bg-cs-main-600 rounded-lg transition-colors">
                                Save
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Modal Content Contact List -->
                <div class="mt-6 pt-4 border-t border-gray-100">
                    <div class="flex items-center justify-between mb-3">
                        <h4 class="text-sm font-medium text-gray-600">
                            Existing Contacts
                        </h4>
                        <button type="button" class="btn btn-xs bg-cs-main-500 text-white hover:bg-cs-main-600 rounded-lg px-3 py-1 transition-colors duration-300 flex items-center gap-1 normal-case text-xs" @click="handleRefreshContacts">
                            <IconRefresh size="14"
                                class="opacity-80 transition-transform duration-300 group-hover:rotate-180" />
                            Refresh
                        </button>
                    </div>
                    <input v-model="searchKey" type="text" class="input input-sm input-bordered w-full mb-3 bg-white border-gray-200 focus:border-cs-main-500"
                        placeholder="Search contacts...">

                    <div class="relative overflow-x-auto rounded-lg border border-gray-100 max-h-64 overflow-y-auto">
                        <table class="w-full text-sm text-left">
                            <thead class="text-xs text-gray-500 uppercase bg-gray-50 sticky top-0">
                                <tr>
                                    <th scope="col" class="px-4 py-2 font-medium">
                                        Name
                                    </th>
                                    <th scope="col" class="px-4 py-2 font-medium">
                                        Email
                                    </th>
                                    <th scope="col" class="px-4 py-2 font-medium text-center w-24">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Edit Form Row -->
                                <tr
                                  v-if="editingContactIndex !== null"
                                  class="border-b hover:bg-cs-main-200"
                                >
                                  <td class="px-4 py-2">
                                    <input
                                      v-model="editForm.name"
                                      type="text"
                                      class="input input-xs input-bordered w-full bg-white border-gray-200 focus:border-cs-main-500"
                                      placeholder="Name"
                                      @click.stop
                                    />
                                    <div
                                      v-if="editContactErrors.name"
                                      class="text-red-500 text-xs mt-1"
                                    >
                                      {{ editContactErrors.name }}
                                    </div>
                                  </td>
                                  <td class="px-4 py-2">
                                    <input
                                      v-model="editForm.email"
                                      type="text"
                                      class="input input-xs input-bordered w-full bg-white border-gray-200 focus:border-cs-main-500"
                                      placeholder="Email"
                                      @click.stop
                                    />
                                    <div
                                      v-if="editContactErrors.email"
                                      class="text-red-500 text-xs mt-1"
                                    >
                                      {{ editContactErrors.email }}
                                    </div>
                                  </td>
                                  <td class="px-4 py-2 text-center">
                                    <div class="flex items-center justify-center gap-1">
                                      <button
                                        type="button"
                                        class="p-1 text-green-600 hover:bg-green-50 rounded transition-colors"
                                        title="Save Changes"
                                        @click.stop="onSaveEditContact"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <path d="M20 6L9 17l-5-5" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        class="p-1 text-gray-400 hover:bg-gray-100 rounded transition-colors"
                                        title="Cancel"
                                        @click.stop="cancelEditContact"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <line x1="18" y1="6" x2="6" y2="18" />
                                          <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                                <!-- Contact Rows -->
                                <tr v-for="(contact, index) in allContacts" :key="`contact-${index}`"
                                    class="border-b hover:cursor-pointer hover:bg-gray-50 transition-colors"
                                    :class="{ 'bg-yellow-50': editingContactIndex === index }"
                                    @click="handleSelectContact(contact)">
                                    <td class="px-4 py-2 text-gray-700">
                                        {{ contact.name }}
                                    </td>
                                    <td class="px-4 py-2 text-gray-500">
                                        {{ contact.email }}
                                    </td>
                                    <td class="px-4 py-2 text-center">
                                      <div class="flex items-center justify-center gap-1">
                                        <template v-if="contact.source === 'contact_book'">
                                          <button
                                            type="button"
                                            class="p-1 text-blue-500 hover:bg-blue-50 rounded transition-colors"
                                            title="Edit Contact"
                                            @click.stop="onEditContact(contact, index)"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            >
                                              <path
                                                d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                                              />
                                            </svg>
                                          </button>
                                          <button
                                            type="button"
                                            class="p-1 text-red-400 hover:bg-red-50 rounded transition-colors"
                                            title="Delete Contact"
                                            @click.stop="onDeleteContact(contact, index)"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            >
                                              <polyline points="3 6 5 6 21 6" />
                                              <path
                                                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                              />
                                            </svg>
                                          </button>
                                        </template>
                                        <span
                                          v-else-if="contact.source === 'contact'"
                                          class="text-gray-400 text-xs italic"
                                          title="This contact is managed by your organization and cannot be edited."
                                        >Managed</span>
                                        <template v-else>
                                          <span
                                            class="text-amber-400 text-xs italic inline-flex items-center gap-0.5 flex-shrink-0"
                                            title="This contact is temporary and will be removed after refresh. It is not saved to your contact list."
                                          ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="inline-block"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>Not saved</span>
                                          <button
                                            type="button"
                                            class="p-1 text-red-400 hover:bg-red-50 rounded transition-colors"
                                            title="Remove Contact?"
                                            @click.stop="onDeleteTempContact(index)"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="14"
                                              height="14"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              stroke-width="2"
                                              stroke-linecap="round"
                                              stroke-linejoin="round"
                                            >
                                              <polyline points="3 6 5 6 21 6" />
                                              <path
                                                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                              />
                                            </svg>
                                          </button>
                                        </template>
                                      </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </Teleport>

    <!-- Delete Confirmation Modal -->
    <Teleport to="body">
      <div
        v-if="isDeleteModalOpen"
        class="fixed inset-0 flex items-center justify-center p-4"
        style="z-index: 1000010"
      >
        <div
          class="fixed inset-0 bg-black bg-opacity-50"
          @click="isDeleteModalOpen = false"
        ></div>
        <div class="relative bg-white rounded-lg p-6 max-w-sm w-full shadow-xl">
          <h3 class="text-lg font-medium text-gray-900 mb-4">Delete Contact</h3>
          <p class="text-sm text-gray-500 mb-6">
            Are you sure you want to delete
            <span class="font-semibold">{{ contactToDelete?.name }}</span
            >? This action cannot be undone.
          </p>
          <div class="flex justify-end gap-3">
            <button
              type="button"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              @click="isDeleteModalOpen = false"
            >
              Cancel
            </button>
            <button
              type="button"
              class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
              @click="onConfirmDelete"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Delete Temporary Contact Confirmation Modal -->
    <Teleport to="body">
      <div
        v-if="isDeleteTempModalOpen"
        class="fixed inset-0 flex items-center justify-center p-4"
        style="z-index: 1000010"
      >
        <div
          class="fixed inset-0 bg-black bg-opacity-50"
          @click="isDeleteTempModalOpen = false"
        ></div>
        <div class="relative bg-white rounded-lg p-6 max-w-sm w-full shadow-xl">
          <div class="text-center">
            <div
              class="mx-auto flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mb-4"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-red-500"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-800 mb-2">
              Remove contact?
            </h3>
            <p class="font-medium text-gray-800 mb-2">
              "{{ tempContactToDelete?.name || tempContactToDelete?.email }}"
            </p>
            <p class="text-sm text-gray-500 mb-6">
              This contact is temporary and will be removed after refresh. If needed again, it must be re-entered manually.
            </p>
            <div class="flex justify-center gap-3">
              <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 border border-gray-200 rounded-lg hover:bg-gray-200 transition-colors"
                @click="isDeleteTempModalOpen = false"
              >
                Cancel
              </button>
              <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                @click="onConfirmDeleteTemp"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Toast Notification -->
    <Teleport to="body">
      <transition name="toast-fade">
        <div
          v-if="toastMessage"
          class="fixed top-6 right-6 bg-green-500 text-white px-5 py-3 rounded-lg shadow-lg text-sm font-medium flex items-center gap-2"
          style="z-index: 1000010"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
          {{ toastMessage }}
        </div>
      </transition>
    </Teleport>
</template>
<script>
import { IconRefresh } from '@tabler/icons-vue'
import { debounceFilter, watchWithFilter } from '@vueuse/core'

export default {
    name: 'ContactModal',
    components: {
        IconRefresh
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    emits: ['update:modelValue', 'select-contact'],
    data() {
        return {
            allContacts: [],
            searchKey: '',
            newContact: {
                name: '',
                email: ''
            },
            LOCAL_RECEPIENT_FORM_KEY: 'local-receipient-form',
            inputContactErrors: {
                name: '',
                email: ''
            },
            editingContactIndex: null,
            editForm: {
                name: '',
                email: '',
                id: null
            },
            editOriginalEmail: '',
            editContactErrors: {
                name: '',
                email: ''
            },
            isDeleteModalOpen: false,
            contactToDelete: null,
            contactToDeleteIndex: null,
            isDeleteTempModalOpen: false,
            tempContactToDelete: null,
            tempContactToDeleteIndex: null,
            toastMessage: ''
        }
    },
    watch: {
        modelValue(newVal) {
            if (newVal && this.allContacts.length === 0) {
                this.getAllContacts(this.searchKey)
            }
        }
    },
    mounted() {
        watchWithFilter(
            () => this.searchKey,
            () => {
                this.getAllContacts(this.searchKey)
            },
            { eventFilter: debounceFilter(500, { maxWait: 1000 }) }
        )

        // Add event listener for ESC key to close modal
        window.addEventListener('keydown', this.handleEsc)
    },
    beforeUnmount() {
        // Clean up event listener
        window.removeEventListener('keydown', this.handleEsc)
        if (this.toastTimeoutId) clearTimeout(this.toastTimeoutId)
    },
    methods: {
        showToast(message) {
            if (this.toastTimeoutId) clearTimeout(this.toastTimeoutId)
            this.toastMessage = message
            this.toastTimeoutId = setTimeout(() => {
                this.toastMessage = ''
            }, 3000)
        },
        closeModal() {
            this.$emit('update:modelValue', false)
        },
        handleEsc(event) {
            if (event.key === 'Escape' && this.modelValue) {
                this.closeModal()
            }
        },
        async getAllContacts(text) {
            const q = text.split(/[;,]+/).pop().trim()
            const queryParams = new URLSearchParams({ q })
            const keyword = this.searchKey.trim().toLowerCase() || ''

            try {
                const resp = await fetch('/submitters_autocomplete?' + queryParams)
                const fetched = await resp.json()

                const filtered = keyword
                    ? fetched.filter(c =>
                        (c.email && c.email.toLowerCase().includes(keyword)) ||
                        (c.name && c.name.toLowerCase().includes(keyword))
                    )
                    : fetched

                this.allContacts = filtered
            } catch (error) {
                console.error('Error fetching contacts:', error)
            }
        },
        handleSelectContact(contact) {
            // Set the contact information in recepient contact storage
            localStorage.setItem(this.LOCAL_RECEPIENT_FORM_KEY, JSON.stringify(contact))

            // Emit event to parent with selected contact
            this.$emit('select-contact', contact)

            // Close modal
            this.closeModal()
        },
        handleSubmitNewContact() {
            // Reset previous errors
            this.inputContactErrors = {
                name: '',
                email: ''
            }

            // Basic validation
            let hasError = false
            if (!this.newContact.name) {
                this.inputContactErrors.name = 'Name is required'
                hasError = true
            }

            if (!this.newContact.email) {
                this.inputContactErrors.email = 'Email is required'
                hasError = true
            }

            if (hasError) return

            const nameLower = this.newContact.name.trim().toLowerCase()
            const emailLower = this.newContact.email.trim().toLowerCase()

            // Only check duplicates against DB-sourced contacts (contact_book and contact)
            const dbContacts = this.allContacts.filter(contact =>
                contact.source === 'contact_book' || contact.source === 'contact'
            )

            const isDuplicateName = dbContacts.some(contact =>
                contact.name?.toLowerCase() === nameLower
            )
            const isDuplicateEmail = dbContacts.some(contact =>
                contact.email?.toLowerCase() === emailLower
            )

            if (isDuplicateName) {
                this.inputContactErrors.name = 'Name already exists'
            }

            if (isDuplicateEmail) {
                this.inputContactErrors.email = 'Email already exists'
            }

            if (isDuplicateName || isDuplicateEmail) return

            // Remove any temporary (Not saved) contacts with the same email or name before saving
            this.allContacts = this.allContacts.filter(c =>
                c.source === 'contact_book' ||
                c.source === 'contact' ||
                (c.email?.toLowerCase() !== emailLower &&
                 c.name?.toLowerCase() !== nameLower)
            )

            // Save to database via API
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
            fetch('/api/contact_books', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                },
                body: JSON.stringify({
                    contact_book: { name: this.newContact.name.trim(), email: this.newContact.email.trim() }
                })
            }).then(resp => resp.json()).then(async data => {
                if (data.contact?.id) {
                    await this.getAllContacts(this.searchKey)
                    this.showToast('Contact added successfully.')
                }
            }).catch(err => console.error('Failed to save contact to DB:', err))

            // Set contact information to recepient contact storage
            localStorage.setItem(this.LOCAL_RECEPIENT_FORM_KEY, JSON.stringify(this.newContact))

            // Emit event to parent with new contact
            this.$emit('select-contact', this.newContact)

            // Close modal
            this.closeModal()

            // Reset form
            this.newContact = { name: '', email: '' }
        },
        onEditContact(contact, index) {
            this.editingContactIndex = index
            this.editForm = {
                name: contact.name || '',
                email: contact.email || '',
                id: contact.id || null
            }
            this.editOriginalEmail = contact.email || ''
            this.editContactErrors = { name: '', email: '' }
        },
        cancelEditContact() {
            this.editingContactIndex = null
            this.editForm = { name: '', email: '', id: null }
            this.editContactErrors = { name: '', email: '' }
        },
        async onSaveEditContact() {
            this.editContactErrors = { name: '', email: '' }
            let hasError = false
            
            if (!this.editForm.name.trim()) {
                this.editContactErrors.name = 'Name is required'
                hasError = true
            }
            
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!this.editForm.email.trim()) {
                this.editContactErrors.email = 'Email is required'
                hasError = true
            } else if (!emailPattern.test(this.editForm.email.trim())) {
                this.editContactErrors.email = 'Invalid email format'
                hasError = true
            }
            
            const emailLower = this.editForm.email.trim().toLowerCase()
            const isDuplicateEmail = this.allContacts.some(
                c => c.email?.toLowerCase() === emailLower && c.email?.toLowerCase() !== this.editOriginalEmail.toLowerCase()
            )
            
            if (isDuplicateEmail) {
                this.editContactErrors.email = 'Email already exists'
                hasError = true
            }
            
            if (hasError) return
            
            const updatedName = this.editForm.name.trim()
            const updatedEmail = this.editForm.email.trim()
            
            if (this.editForm.id) {
                try {
                    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
                    const resp = await fetch(`/api/contact_books/${this.editForm.id}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': csrfToken
                        },
                        body: JSON.stringify({
                            contact_book: { name: updatedName, email: updatedEmail }
                        })
                    })
                    if (!resp.ok) {
                        console.error('Failed to update contact on server')
                    }
                } catch (err) {
                    console.error('Error updating contact on server:', err)
                }
            }
            
            const originalEmailLower = this.editOriginalEmail.toLowerCase()
            
            if (this.editingContactIndex !== null && this.allContacts[this.editingContactIndex]) {
                this.allContacts[this.editingContactIndex].name = updatedName
                this.allContacts[this.editingContactIndex].email = updatedEmail
            }
            
            this.cancelEditContact()
            this.showToast('Contact updated successfully.')
        },
        onDeleteContact(contact, index) {
            this.contactToDelete = contact
            this.contactToDeleteIndex = index
            this.isDeleteModalOpen = true
        },
        async onConfirmDelete() {
            if (!this.contactToDelete) return
            
            const contact = this.contactToDelete
            
            if (contact.id && contact.source === 'contact_book') {
                try {
                    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
                    const resp = await fetch(`/api/contact_books/${contact.id}`, {
                        method: 'DELETE',
                        headers: {
                            'X-CSRF-Token': csrfToken
                        }
                    })
                    if (!resp.ok) {
                        console.error('Failed to delete contact on server')
                    }
                } catch (err) {
                    console.error('Error deleting contact on server:', err)
                }
            }
            
            const contactEmailLower = contact.email?.toLowerCase()
            
            this.allContacts = this.allContacts.filter(c => c.email?.toLowerCase() !== contactEmailLower)
            
            if (this.editingContactIndex === this.contactToDeleteIndex) {
                this.cancelEditContact()
            }
            
            this.isDeleteModalOpen = false
            this.contactToDelete = null
            this.contactToDeleteIndex = null
            this.showToast('Contact deleted successfully.')
        },
        onDeleteTempContact(index) {
            const contact = this.allContacts[index]
            if (!contact) return

            this.tempContactToDelete = contact
            this.tempContactToDeleteIndex = index
            this.isDeleteTempModalOpen = true
        },
        onConfirmDeleteTemp() {
            if (this.tempContactToDeleteIndex === null) return

            this.allContacts.splice(this.tempContactToDeleteIndex, 1)
            this.showToast('Temporary contact removed.')

            this.isDeleteTempModalOpen = false
            this.tempContactToDelete = null
            this.tempContactToDeleteIndex = null
        },
        async handleRefreshContacts() {
            await this.getAllContacts(this.searchKey)
            this.showToast('Contacts refreshed from server.')
            console.log('Contacts refreshed from server.')
        }
    }
}
</script>

<style scoped>
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
